import { VisuallyHidden } from '@vkontakte/vkui';
import { MessageBubble, MessageBubbleProps } from '../MessageBubble/MessageBubble';
import { TypingIcon } from '../../src/icons';
import styles from './MessageBubbleTyping.module.css';

export interface MessageBubbleTypingProps {
  className?: string;
  /** Цветовой стиль */
  mode?: MessageBubbleProps['mode'];
  label?: string;
  testId?: string;
}

export function MessageBubbleTyping(props: MessageBubbleTypingProps) {
  const { className, mode, label, testId } = props;

  return (
    <MessageBubble testId={testId} className={className} mode={mode}>
      <TypingIcon className={styles.icon} />
      <VisuallyHidden>{label}</VisuallyHidden>
    </MessageBubble>
  );
}
